export default __webpack_public_path__ + "static/media/download_methodiek_terug en vooruitdenken.259e0539.pdf";